var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"page",attrs:{"id":"page"}},[_c('TopBar'),_c('Header'),_c('router-view',{key:_vm.$route.path}),_c('Footer')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }